import { render, staticRenderFns } from "./SettingsPaymentPaypal.vue?vue&type=template&id=c2043d52&lang=pug&"
import script from "./SettingsPaymentPaypal.vue?vue&type=script&lang=js&"
export * from "./SettingsPaymentPaypal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2043d52')) {
      api.createRecord('c2043d52', component.options)
    } else {
      api.reload('c2043d52', component.options)
    }
    module.hot.accept("./SettingsPaymentPaypal.vue?vue&type=template&id=c2043d52&lang=pug&", function () {
      api.rerender('c2043d52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/settings/SettingsPayment/SettingsPaymentPaypal.vue"
export default component.exports